import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  Button,
  Checkbox,
  TextField,
  Divider,
  FormHelperText,
} from "@mui/material";
import "./SelectMovie.css";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
// import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { selectVideoSchema } from "../../validations/selectVideoAndSubValidation";
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import { FormLabel } from "@mui/material";
import * as Yup from "yup";
import DraggableComponent from "./DraggableComponent";
import { customToastify } from "../pages/utils/utilsFunctions";
export default function SelectMovie(props) {
  const {
    selectVideoBox,
    handleCloseSelectVideoBox,
    fullscreenState,
    handleFullScreen,
    handleFullscreenState,
    handleMainCompareSubsOpen,
  } = props;
  const { handleVideoInfo, videoInfo, handleOpenSignInBox, userTypes } =
    useContext(MainContext);
  const [typeOfVideo, setTypeOfVideo] = useState("movie");
  const [fileName, setFileName] = useState("انتخاب فایل فیلم");
  const [filmName, setFilmName] = useState("");

  const initialValues = {
    videoType: videoInfo.videoType || "movie",
    filmName: videoInfo.filmName || "",
    season: videoInfo.season || "",
    episode: videoInfo.season || "",
    videoFile: videoInfo.videoFile || "",
    config: {},
  };

  const onSubmit = (values, props) => {
    let newValues = {
      videoType: values.videoType,
      filmName: filmName || videoInfo["filmName"],
      fileName,
      season: values.season,
      episode: values.episode,
      // videoFile: values.videoFile,
      subtitleOneLanguage: videoInfo["subtitleOneLanguage"] || "",
      subtitleOneFile: videoInfo["subtitleOneFile"] || "",
      subtitleOneSearchBox: false,
      subtitleOneRtl: false,
      subtitleTwoLanguage: videoInfo["subtitleTwoLanguage"] || "",
      subtitleTwoFile: videoInfo["subtitleTwoFile"] || "",
      subtitleTwoearchBox: false,
      subtitleTwoRtl: false,
      subtitleTwoOff: videoInfo["subtitleTwoOff"] || false,
    };
    handleVideoInfo({
      ...videoInfo,
      ...newValues,
    });
    if (userTypes.length > 0) {
      handleMainCompareSubsOpen(true);
      handleCloseSelectVideoBox();
      if (fullscreenState && !handleFullScreen.active) {
        handleFullScreen.enter();
      }
    } else {
      handleOpenSignInBox();
      setTimeout(() => {
        customToastify(
          "error",
          "لطفا ابتدا وارد شوید و سپس بر روی مقایسه و انتخاب کلیک کنید"
        );
      }, 500);
    }
  };

  React.useEffect(() => {
    setFileName(videoInfo["fileName"]);
  }, [videoInfo]);
  return (
    <DraggableComponent>
      <Paper
        sx={{
          display: selectVideoBox ? "block !important" : "none !important",
          width: "100%",
          position: "relative",
          textAlign: "justify",
          borderRadius: "10px",
          pb: 2,
        }}
      >
        <Divider sx={{ textAlign: "center" }}>مشخصات فیلم</Divider>
        <Typography sx={{ fontSize: "11px" }}>
          {`نام فایل:${fileName}`}
        </Typography>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={selectVideoSchema}
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form>
                <TextField
                  id="outlined-basic"
                  sx={{ mx: 1, mb: 1, width: "100%" }}
                  value={filmName}
                  onChange={(event) => {
                    setFilmName(event.target.value);
                  }}
                  label="نام فیلم و سریال"
                  variant="outlined"
                  size="small"
                />
                <FormControl
                  component="fieldset"
                  sx={{
                    mx: 1,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <FormLabel component="legend">نوع فیلم</FormLabel>
                  <Field
                    as={RadioGroup}
                    onClick={(e) => {
                      setTypeOfVideo(e.target.value);
                    }}
                    aria-label="videoType"
                    name="videoType"
                    sx={{ display: "flex", flexDirection: "row" }}
                    value={typeOfVideo}
                  >
                    <FormControlLabel
                      value="movie"
                      control={<Radio />}
                      label="فیلم"
                    />
                    <FormControlLabel
                      value="Serial"
                      control={<Radio />}
                      label="سریال"
                    />
                    <FormControlLabel
                      value="clip"
                      control={<Radio />}
                      label="کلیپ"
                    />
                    {/* <FormControlLabel value="clip" control={<Radio />} label="مجموعه آموزشی" /> */}
                  </Field>
                  <FormHelperText
                    sx={{ color: "#f96767", textAlign: "center" }}
                  >
                    <ErrorMessage name="videoType" />
                  </FormHelperText>
                </FormControl>

                {typeOfVideo !== "Serial" ? null : (
                  <>
                    <Field
                      as={TextField}
                      sx={{ mx: 1, mb: 1 }}
                      type="number"
                      name="season"
                      label="فصل"
                      size="small"
                      disabled={typeOfVideo !== "Serial"}
                      placeholder="شماره فصل"
                    />
                    <FormHelperText
                      sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
                    >
                      <ErrorMessage name="season" />
                    </FormHelperText>

                    <Field
                      as={TextField}
                      sx={{ mx: 1 }}
                      type="number"
                      name="episode"
                      label=" قسمت"
                      size="small"
                      disabled={typeOfVideo !== "Serial"}
                      placeholder="شماره قسمت"
                    />
                    <FormHelperText
                      sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
                    >
                      <ErrorMessage name="episode" />
                    </FormHelperText>
                  </>
                )}
                <Box
                  sx={{
                    mx: 1,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ mx: 2 }}
                    onClick={() => {
                      setFilmName("");
                      handleCloseSelectVideoBox();
                      if (
                        videoInfo.videoFile &&
                        fullscreenState &&
                        !handleFullScreen.active
                      ) {
                        handleFullScreen.enter();
                      }
                    }}
                    color="error"
                  >
                    بستن
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ mx: 2, mt: 0.5 }}
                    color="success"
                  >
                    مقایسه و انتخاب بهترین زیرنویس
                  </Button>
                </Box>
                <Divider sx={{ mt: 1 }} />
                <FormControlLabel
                  sc={{
                    display: "flex",
                    flexDirection: "colum",
                    color: "#ef657d",
                  }}
                  onChange={(e) => {
                    handleFullscreenState(!fullscreenState);
                  }}
                  name="FullscreenState"
                  control={
                    <Checkbox
                      size="small"
                      checked={fullscreenState}
                      color="error"
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "small" }}>
                      ادامه با نمایش تمام صفحه
                    </Typography>
                  }
                />
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Paper>
    </DraggableComponent>
  );
}
